import gql from 'graphql-tag';

type EnrollMutationInput = {
  data: {
    type: 'users';
    attributes: {
      country_code: string;
      enroll_to_loyalty: boolean;
    };
    id: string;
  };
};

export type EnrollMutationVariables = {
  id: string;
  input: EnrollMutationInput;
};

export type EnrollMutation = {
  __typename: 'RestEnrollPayload';
};

export const ENROLL_MUTATION = gql`
  mutation EnrollMutation($id: String!, $input: EnrollMutationInput!) {
    enroll(id: $id, input: $input)
      @rest(
        type: "RestEnrollPayload"
        endpoint: "cart"
        path: "/v3.3/users/{args.id}"
        method: "PATCH"
      ) {
      NoResponse
    }
  }
`;
